module.exports = __webpack_public_path__ + "static/media/build_website_img.9a122c10.png";